import { StorageManager } from "./storage";
export const SessionStorage = new StorageManager(localStorage);
